import { render, staticRenderFns } from "./FittingsDelivery.vue?vue&type=template&id=c68d9d24&scoped=true"
import script from "./FittingsDelivery.vue?vue&type=script&lang=js"
export * from "./FittingsDelivery.vue?vue&type=script&lang=js"
import style0 from "./FittingsDelivery.vue?vue&type=style&index=0&id=c68d9d24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68d9d24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c68d9d24')) {
      api.createRecord('c68d9d24', component.options)
    } else {
      api.reload('c68d9d24', component.options)
    }
    module.hot.accept("./FittingsDelivery.vue?vue&type=template&id=c68d9d24&scoped=true", function () {
      api.rerender('c68d9d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsDelivery/FittingsDelivery.vue"
export default component.exports